var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 85,
    viewBox: "0 0 162 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_6634_7940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1148 84.934C125.667 84.934 161.784 80.9671 161.784 76.0736C161.784 71.1801 125.667 67.2131 81.1148 67.2131C36.5623 67.2131 0.445312 71.1801 0.445312 76.0736C0.445312 80.9671 36.5623 84.934 81.1148 84.934Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.553 77.9799H38.8359L51.2287 7.52222H136.945L124.553 77.9799Z",
    fill: "#808486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.564 0.223999H52.5123L51.2266 7.52216H81.2476L80.564 0.223999Z",
    fill: "#808486"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.553 77.9799H38.8359L51.2287 7.52222H136.945L124.553 77.9799Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.564 0.223999H52.5123L51.2266 7.52216H81.2476L80.564 0.223999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.4844 3.20194C49.2969 2.39495 49.2969 1.55553 49.4844 0.748535C49.672 1.55553 49.672 2.39495 49.4844 3.20194Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9922 3.92386C46.7058 3.62612 46.459 3.29247 46.258 2.93122C46.0471 2.5775 45.8817 2.1985 45.7656 1.80322C46.0529 2.09921 46.2998 2.43204 46.4999 2.79304C46.7103 3.148 46.8757 3.52787 46.9922 3.92386Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1966 5.79909C44.406 5.55816 43.6813 5.13847 43.0781 4.57239C43.4725 4.6873 43.8507 4.85219 44.2035 5.06306C44.5639 5.26585 44.8975 5.51311 45.1966 5.79909Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5648 8.32583C43.7597 8.51386 42.9223 8.51386 42.1172 8.32583C42.9223 8.13781 43.7597 8.13781 44.5648 8.32583Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2953 10.8243C44.997 11.11 44.6644 11.3572 44.305 11.5604C43.9523 11.7712 43.5741 11.9361 43.1797 12.051C43.4767 11.7639 43.8096 11.5165 44.17 11.315C44.5222 11.1031 44.9005 10.9382 45.2953 10.8243Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1613 12.6263C46.9218 13.42 46.503 14.1475 45.9375 14.7526C46.0521 14.3568 46.2176 13.9776 46.4298 13.6246C46.6304 13.2621 46.8762 12.9266 47.1613 12.6263Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6883 13.2496C49.7864 13.651 49.8337 14.0631 49.829 14.4763C49.835 14.8896 49.7878 15.3019 49.6883 15.703C49.5875 15.3022 49.5402 14.8897 49.5476 14.4763C49.543 14.0631 49.5902 13.651 49.6883 13.2496Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1797 12.5418C52.4661 12.8395 52.713 13.1732 52.914 13.5344C53.1254 13.8875 53.2899 14.2667 53.4035 14.6624C52.838 14.0573 52.4192 13.3297 52.1797 12.5361V12.5418Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9766 10.6523C54.3714 10.7662 54.7497 10.9311 55.1019 11.143C55.4623 11.3445 55.7951 11.5919 56.0922 11.879C55.6974 11.7652 55.3191 11.6002 54.9669 11.3884C54.6065 11.1869 54.2736 10.9395 53.9766 10.6523Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5938 8.12559C55.3998 7.93763 56.2381 7.93763 57.0442 8.12559C56.2381 8.31355 55.3998 8.31355 54.5938 8.12559Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8728 5.62709C54.1706 5.34168 54.5034 5.09531 54.8631 4.89389C55.2147 4.67997 55.5931 4.51401 55.9884 4.40039C55.3848 4.96726 54.6589 5.38702 53.8672 5.62709H53.8728Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0078 3.8251C52.1236 3.43019 52.2881 3.05128 52.4973 2.6971C52.6983 2.33586 52.9451 2.00221 53.2316 1.70447C53.118 2.10019 52.9535 2.47939 52.7421 2.83247C52.5411 3.19372 52.2943 3.52736 52.0078 3.8251Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.426 77.9799H38.5267L26.3281 10.08H112.23L124.426 77.9799Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0936 51.5875C58.0653 51.5875 59.6637 49.9853 59.6637 48.0089C59.6637 46.0325 58.0653 44.4303 56.0936 44.4303C54.1218 44.4303 52.5234 46.0325 52.5234 48.0089C52.5234 49.9853 54.1218 51.5875 56.0936 51.5875Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3201 51.5875C86.2918 51.5875 87.8902 49.9853 87.8902 48.0089C87.8902 46.0325 86.2918 44.4303 84.3201 44.4303C82.3484 44.4303 80.75 46.0325 80.75 48.0089C80.75 49.9853 82.3484 51.5875 84.3201 51.5875Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3389 52.1599L75.1419 51.7849C75.1251 51.751 73.2795 48.3332 69.5687 48.3332C66.1927 48.3332 65.3487 51.5508 65.3262 51.689L65.2249 52.0979L64.4062 51.9005L64.5047 51.4888C64.5047 51.4493 65.5119 47.4872 69.5687 47.4872C73.7887 47.4872 75.8059 51.2321 75.8903 51.3929L76.0872 51.7651L75.3389 52.1599Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6634_7940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.16cf00a2634d5ae2ebc1d381552d49bd.svg";
export { ForwardRef as ReactComponent };